import i18next from 'i18next';

i18next.addResources('es', 'error', {
  notFound: 'No pudimos encontrar esta página o link.',
  noExist:
    'Puede que la página que busque ya no exista o haya sido movida. Intente de nuevo o vuelva al inicio. Disculpe las molestias.',
  backToHome: 'Volver al Inicio'
});

i18next.addResources('en', 'error', {
  notFound: 'We could not find this page or link.',
  noExist:
    'The page you are looking for may no longer exist or may have been moved. Please try again or return to the home page. We apologize for the inconvenience.',
  backToHome: 'Back to Home'
});

i18next.addResources('pt', 'error', {
  notFound: 'Não conseguimos encontrar esta página ou link.',
  noExist:
    'A página que você procura pode não existir mais ou foi movida. Tente novamente ou volte ao início. Pedimos desculpas pelo inconveniente.',
  backToHome: 'Voltar ao Início'
});
